import { render, staticRenderFns } from "./purchaseApi.vue?vue&type=template&id=c3b5f95c&scoped=true"
import script from "./purchaseApi.vue?vue&type=script&lang=js"
export * from "./purchaseApi.vue?vue&type=script&lang=js"
import style0 from "./purchaseApi.vue?vue&type=style&index=0&id=c3b5f95c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c3b5f95c",
  null
  
)

export default component.exports